import { sendDelete, sendGet, sendPost, sendPut } from "./axios";

export const getListPaymentMethod = (params) => sendGet("/payment-methods", params);
export const createPaymentMethod = (params) => sendPost("/payment-methods", params);

export const updatePaymentMethod = (id, params) =>
  sendPut(`/payment-methods/${id}`, params);

export const deletePaymentMethod = (id) => sendDelete(`/payment-methods/${id}`);
